import React, { useEffect, useState } from 'react';
import styles from './ProducedBy.module.css';

const albums = [
  {
    title: 'Animal',
    artist: 'Taylor Appelo',
    href: 'https://open.spotify.com/album/3lWaKsq5qdMZfdeibLqpBl?si=81VFBeohSfm3LvKf086L8g',
    src: 'https://benjamincleek.s3.us-west-2.amazonaws.com/photos/108a133b-ed00-4a9d-863a-883cae591b45-Taylor%20Appelo%20-%20Animal.png',
  },
  {
    title: 'Midnight Catches',
    artist: 'Illya deTorres',
    href: 'https://open.spotify.com/album/4nae493gDwLmnzgFHOfCm5?si=UeRxgAUESQazwA4z3D2QXA',
    src: 'https://benjamincleek.s3.us-west-2.amazonaws.com/photos/e7adb590-e6ab-407a-afee-484393cf7037-Illya%20-%20Midnight%20Catches%202025%20Screen%20Shot%202025-02-01%20at%205.44.12%20PM.png',
  },
  {
    title: 'Weather The Storms',
    artist: 'Melissa Dollar',
    href: 'https://open.spotify.com/album/69oQKwLh98k7Sm2QhNEOUO?si=c5OqsuafQIG5RWi9BUUhFQ',
    src: 'https://benjamincleek.s3.us-west-2.amazonaws.com/photos/eeda35d9-62ac-45ab-bc99-4117adb048cb-Melissa%20Dollar%20-%20Weather%20The%20Storm.jpg',
  },
  {
    title: 'American Harmony',
    artist: 'David Van Auken',
    href: 'https://open.spotify.com/album/1UyI9mHSPdfpanT5D0boDJ?si=yyn1kNu_SCOcOFVBK7XUlQ',
    src: 'https://benjamincleek.s3.us-west-2.amazonaws.com/photos/5d603355-c3d4-4f02-996a-265041ffab37-American%20Harmoney%20-%20David%20Van%20Auken.jpg',
  },
  {
    title: 'Dumkutwaf',
    artist: 'Blakey Boy',
    href: 'https://open.spotify.com/artist/32KAHfPyZwfR8CNw48TNws',
    src: 'https://benjamincleek.s3.us-west-2.amazonaws.com/photos/70ba801b-40a2-4654-ad7e-c20a2724d93e-Blakie%20Boy.png',
  },
  {
    title: 'Francisco The Man',
    artist: 'Zach Orr',
    href: 'https://open.spotify.com/album/78m8UTCOjvzLFhUNgSkibv',
    src: 'https://benjamincleek.s3.us-west-2.amazonaws.com/photos/54304fd4-1c83-4cf0-ace6-5d6d7c7924a8-francisco%20the%20man.jpg',
  },
  {
    title: 'Removed',
    artist: 'Benjamin Cleek',
    href: 'https://open.spotify.com/album/3upmkHrUFa7eYRKMywGJMl?si=QoHSyelxSR-Fus7HHfzeng',
    src: 'https://benjamincleek.s3.us-west-2.amazonaws.com/photos/b82de2de-68fb-47f0-bf85-dcf09c581807-Removed.png',
  },
  {
    title: 'Rendition',
    artist: 'Walkfast',
    href: 'https://open.spotify.com/album/5x9RZtFiBZKBVED1gbyvvO?si=GdgCWgzmRYe6UR4c5MiO0Q',
    src: 'https://benjamincleek.s3.us-west-2.amazonaws.com/photos/48da9504-f09d-4f23-b490-d643a8c5ee4b-Screen%20Shot%202025-02-26%20at%205.40.54%20PM.png',
  },
  {
    title: 'Dreams Of Venus',
    artist: 'VYVYV',
    href: 'https://vyvyv.bandcamp.com/album/dreams-of-venus',
    src: 'https://benjamincleek.s3.us-west-2.amazonaws.com/photos/3a69f916-2b5c-4f55-bec6-33a8fcdb81e3-vyvyv%20-%20what%20dreams%20may%20cme.png',
  },
  {
    title: 'Walkfast',
    artist: 'Walkfast',
    href: 'https://open.spotify.com/album/2aGR6um2XgkW6CLchQ0MCQ?si=7FPu7rCMT4SbqQPNi06aCQ',
    src: 'https://benjamincleek.s3.us-west-2.amazonaws.com/photos/58ddb852-7cd5-46a5-93fe-f72ff5ff3328-Screen%20Shot%202025-02-26%20at%205.40.15%20PM.png',
  },
  {
    title: 'Babel Echo',
    artist: 'The Molting',
    href: 'https://open.spotify.com/album/6Pkoq8IXgLAdNEkQ32fnx8?si=Px5lWBqeScGKqbzjumsp0g',
    src: 'https://benjamincleek.s3.us-west-2.amazonaws.com/photos/8a4fc3b2-d8dd-4e67-bc06-8e2d64a7a79a-The%20Molting%20-%20Babel%20Echo.png',
  },
];

const ProducedBy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.producedBy}>
      <div className={styles.Albums}>
        {albums.map((album) => (
          <div key={`${album.artist}-${album.title}`} className={styles.featuredAlbums}>
            <a
              href={album.href}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.albumLink}
            >
              <img
                src={album.src}
                alt={`${album.artist} - ${album.title}`}
                className={styles.albumImage}
              />
              <div className={styles.albumOverlay}>
                <h2 className={styles.albumTitle}>{album.title}</h2>
                <p className={styles.albumArtist}>{album.artist}</p>
              </div>
            </a>
            <div className={styles.caption}>
              <p className={styles.captionTitle}>{album.title}</p>
              <p className={styles.captionArtist}>{album.artist}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProducedBy;
